/** @jsxImportSource @emotion/react */
import { Table, Typography, useTheme } from '@quickbit/qb-design-system';
import { RulesOverview } from 'tabs/RulesEngine/api';

export const RuleOverviewTable = ({
  handleRowClicked,
  overviews,
}: {
  handleRowClicked: (ruleName: any) => void;
  overviews: RulesOverview[];
}) => {
  const { spacing, palette } = useTheme();

  const enabledRules = overviews.filter((o) => o.isEnabled !== false);
  const disabledRules = overviews.filter((o) => o.isEnabled === false);

  const headers = [
    { label: 'Rule name', cellKey: 'ruleName', sort: false },
    {
      label: 'Total users',
      cellKey: 'total',
      sort: false,
    },
    { label: 'Unique users', cellKey: 'unique', sort: false },
    { label: 'Tags', cellKey: 'tags', sort: false },
  ];

  const mapToRows = (rules: RulesOverview[]) =>
    rules.map((overview) => ({
      value: {
        ruleName: overview.name,
        total: overview.total,
        unique: overview.uniqueUsers,
        tags: overview.tags?.join(', ') || '-',
      },
    }));

  return (
    <div
      css={{
        marginBottom: spacing.xs,
        'tr:first-child': {
          'td:first-child': { width: '25%' },
          'td:nth-child(2)': { width: '10%' },
        },
      }}
    >
      <Table
        headers={headers}
        rows={mapToRows(enabledRules)}
        onRowClick={handleRowClicked}
      />

      {disabledRules.length > 0 && (
        <div css={{ marginTop: spacing.m }}>
          <div css={{ marginBottom: spacing.xs }}>
            <Typography variant="subtitle" color={palette.grey.x300}>
              Disabled Rules
            </Typography>
          </div>
          <Table
            headers={headers}
            rows={mapToRows(disabledRules)}
            onRowClick={handleRowClicked}
          />
        </div>
      )}
    </div>
  );
};
